import { useState, useEffect, useMemo, useCallback } from "react";
import TablaMRT from "../../features/table/RTable";
import CustomButton from "../../ui/button/Button";
import SideMenu from "../../features/sideMenu/SideMenu";
import Chincheta from "../../assets/img/svg/providers/chincheta.svg";
import ChinchetaDesactivada from "../../assets/img/svg/providers/chinchetaDisable.svg";
import Documento from "../../assets/img/svg/providers/documento.svg";
import Proyecto from "../../assets/img/svg/projects/Proyecto.svg";
import NuevoProyecto from "../../assets/img/svg/projects/NuevoProyecto.svg";
import CentroCarga from "../../assets/img/svg/projects/centrodeCarga.svg";
import Ubicacion from "../../assets/img/svg/providers/ubicacion.svg";
import { changeViewProjects } from "../functions/Functions";
import { default as MapElement } from "../../ui/map/Map";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import Clients from "./Clients";
import WorkCenter from "./WorkCenter";
import MarkerProyectoConcluido from "../../assets/img/svg/projects/torre-activo.svg";
import MarkerProyectoEnProceso from "../../assets/img/svg/projects/torre-en-proceso.svg";
import MarkerProyectoInactivo from "../../assets/img/svg/projects/torre-inactivo.svg";
import { useNavigate } from "react-router-dom";
import Personas from "../../assets/img/svg/providers/personas.svg";
import {
  Box,
  IconButton,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { formatEmpresa, highlightText } from "../../utils/functionsFormat";
import {
  headCellLeftAlign,
  headCellCenterAlign,
  bodyCellCenterAlign,
} from "../../utils/columnStyles";
import {
  customStringFilter,
  customNumberFilter,
} from "../../features/table/filterFunctions";
import { defaultCriterios } from "../../constants/projects";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  getTrackerProyectos,
  getTrackerProyectosEvents,
} from "../functions/Notifications";
import LoaderDialog from "../../ui/loader/Loader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DescargarG from "../../assets/img/svg/users/descargarGreen.svg";
import DescargarG2 from "../../assets/img/svg/users/descargar.svg";
import TablaAsignaciones from "./TablaAsignaciones";
import "./Projects.responsive.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import TrackerProjectsStepper from "../../features/stepper/TrackerProjectStepper";
import { abrirReporte, fetchTrabajosConAsignados } from "../functions/Projects";
import { customStrainFilter } from "../../features/table/filterFunctions";

const txt = (s) => (s ?? "").toString().trim().toUpperCase();

const detectTipos = (items = []) => {
  let hasLev = false,
    hasImp = false,
    hasMant = false;
  for (const a of items) {
    const t = txt(
      a?.categoriaParametro?.descripcion ??
        a?.categoriaParametro?.name ??
        a?.faseTrabajo?.descripcion ??
        a?.faseTrabajo?.name ??
        ""
    );
    if (t.includes("LEVANTAMIENTO")) hasLev = true;
    if (t.includes("ENTREGABLE") || t.includes("IMPLEMENTACIÓN")) hasImp = true;
    if (t.includes("MANTENIMIENTO")) hasMant = true;
  }
  return { hasLev, hasImp, hasMant };
};

const Projects = ({ API_URL, user, setUser, companies, perfiles, clients }) => {
  const navigate = useNavigate();

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [data, setData] = useState([]);
  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => {
      const valorA = (a?.cliente?.razonSocial || "").toLowerCase();
      const valorB = (b?.cliente?.razonSocial || "").toLowerCase();
      return valorA.localeCompare(valorB); // DESC
    });
  }, [data]);
  const [markers, setMarkers] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [tableInstance, setTableInstance] = useState(null);
  const [events, setEvents] = useState([
    {
      id: 0,
      id_trabajo: 0,
      id_empresa: null,
      etapa: 1,
      estatus: "completado",
      id_usuario: user.id,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    },
    {
      id: 0,
      id_trabajo: 0,
      id_empresa: null,
      etapa: 2,
      estatus: "pendiente",
      id_usuario: user.id,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    },
  ]);
  const [showLoader, setShowLoader] = useState(false);

  const [detailMode, setDetailMode] = useState("tracker");

  const descargarReporte = async (filename, blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.pdf`;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const toggleRowWithMode = (row, mode) => {
    const expanded = row.getIsExpanded();
    const sameMode = detailMode === mode;

    if (tableInstance) {
      const shouldExpand = expanded ? !sameMode : true;
      if (shouldExpand) {
        tableInstance.setExpanded({ [row.id]: true });
        setDetailMode(mode);
        setSelectedProject(row.original);
      } else {
        tableInstance.resetExpanded();
        setSelectedProject(null);
      }
    }
  };

  const formatNivelTension = (value) => {
    if (!value) return "-";
    switch (value.toLowerCase()) {
      case "baja":
        return "Baja Tensión (BT)";
      case "media":
        return "Media Tensión (MT)";
      case "alta":
        return "Alta Tensión (AT)";
      default:
        return value;
    }
  };

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });

  const [rowCount, setRowCount] = useState(0);

  const arrayViews = user.vistasProyectos
    .split(",")
    .map((num) => parseInt(num.trim(), 10));

  useEffect(() => {
    const fetchData = async () => {
      const [trackerData, response] = await Promise.all([
        getTrackerProyectos(API_URL),
        fetchTrabajosConAsignados(
          API_URL,
          defaultCriterios,
          pagination.pageSize,
          pagination.pageIndex
        ),
      ]);
      console.log("🚀 ~ fetchData ~ response:", response);

      const { trabajosConAsignados, total } = response;

      setRowCount(total);

      const mappedMarkers = trabajosConAsignados.map((item) => ({
        lat: item.latitude,
        lng: item.longitude,
        icon:
          item?.estatus?.nombre === "Concluido"
            ? MarkerProyectoConcluido
            : item?.estatus?.nombre === "En proceso"
            ? MarkerProyectoEnProceso
            : MarkerProyectoInactivo,
      }));

      const newData = trabajosConAsignados.map((t) => {
        const trackerForJob = trackerData.find((tr) => tr.id_trabajo === t.id);
        return trackerForJob
          ? { ...t, etapa: trackerForJob.etapa, tracker: trackerForJob }
          : {
              ...t,
              etapa: 2,
              tracker: {
                id: 0,
                id_usuario: user.id,
                id_trabajo: t.id,
                etapa: 2,
                fecha_actualizacion: new Date().toISOString(),
                estatus: "pendiente",
                tipo: "proyecto",
              },
            };
      });

      setMarkers(mappedMarkers);

      setData(newData);
    };

    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const confirmDialog = useConfirmDialog();

  useEffect(() => {
    const fetchEvents = async () => {
      if (selectedProject) {
        const events = await getTrackerProyectosEvents(
          API_URL,
          selectedProject.id
        );
        if (events.length > 0) {
          setEvents(events);
        } else {
          setEvents([
            {
              id: 0,
              id_trabajo: selectedProject.id,
              id_empresa: null,
              etapa: 1,
              estatus: "completado",
              id_usuario: user.id,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            },
            {
              id: 0,
              id_trabajo: selectedProject.id,
              id_empresa: null,
              etapa: 2,
              estatus: "pendiente",
              id_usuario: user.id,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            },
          ]);
        }
      }
    };
    fetchEvents();
  }, [selectedProject]);

  const columns = [
    {
      id: "cc_asignados",
      header: "Asignaciones",
      size: 100,
      enableColumnActions: false,
      enableColumnFilter: false,
      enableSorting: false,
      enableHiding: false,
      muiTableHeadCellProps: { sx: headCellCenterAlign },
      muiTableBodyCellProps: { sx: bodyCellCenterAlign },
      Cell: ({ row }) => {
        const isThisRowAsignaciones =
          row.getIsExpanded() && detailMode === "asignaciones";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "center",
            }}
          >
            <IconButton
              size="small"
              onClick={() => toggleRowWithMode(row, "asignaciones")}
              title="Ver asignaciones"
            >
              {isThisRowAsignaciones ? (
                <ArrowDropUpIcon color="success" />
              ) : (
                <ArrowDropDownIcon color="success" />
              )}
            </IconButton>
          </div>
        );
      },
    },
    {
      accessorKey: "permisionario.razonSocial",
      header: "Permisionario",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 160,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const filter = table?.getState().globalFilter;
        return highlightText(formateado, filter);
      },
    },
    {
      accessorKey: "cliente.razonSocial",
      header: "Usuario final",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formatted = formatEmpresa(texto);
        const filter = table?.getState().globalFilter;
        return highlightText(formatted, filter);
      },
    },
    {
      accessorKey: "proyecto.nombre",
      header: "Proyecto",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const capitalized = texto
          .toLowerCase()
          .replace(/(?:^|\s|\.|-|\/)\S/g, (char) => char.toUpperCase());
        const filter = table?.getState().globalFilter;
        return highlightText(capitalized, filter);
      },
    },
    {
      accessorKey: "nombre",
      header: "Centro de carga",
      size: 140,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        title: "Centro de carga",
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const search = table?.getState().globalFilter;
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      accessorKey: "rpu",
      header: "RPU",
      size: 140,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        title: "RPU",
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const search = table?.getState().globalFilter;
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      id: "nivelTension",
      accessorKey: "nivelTension",
      header: "Nivel de Tensión",
      filterFn: customStrainFilter,
      meta: { filterVariant: "strain" },
      width: 70,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row }) => (
        <div style={{ textAlign: "center" }}>
          {row.original.nivelTension
            ? formatNivelTension(row.original.nivelTension)
            : "-"}
        </div>
      ),
    },
    {
      id: "demandaContratada",
      accessorKey: "",
      header: "Demanda Contratada (kW)",
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      width: 70,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => (
        <div style={{ textAlign: "center" }}>
          {row.original.demandaContratada
            ? row.original.demandaContratada
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "-"}
        </div>
      ),
    },
    {
      accessorKey: "tipoTrabajo.nombre",
      header: "Estructura de desgloce de trabajo",
      Header: () => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            Estructura de desgloce
          </Box>
          <Box component="span">de trabajo</Box>
        </Box>
      ),
      size: 170,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        title: "Estructura de desgloce de trabajo",
        sx: headCellLeftAlign,
        minWidth: 0,
        overflow: "hidden",
        "& .Mui-TableHeadCell-Content, & .Mui-TableHeadCell-Content-Labels": {
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const capitalized = texto
          .toLowerCase()
          .replace(/(?:^|\s|\.|-|\/)\S/g, (char) => char.toUpperCase());
        const filter = table?.getState().globalFilter;
        return highlightText(capitalized, filter);
      },
    },
  ];

  const renderDetailPanel = useCallback(
    ({ row }) => {
      if (detailMode === "asignaciones") {
        const items = row.original.trabajosAsignados ?? [];

        const asignacionesLevantamiento = items.filter(
          (item) => item.faseTrabajo.name === "LEVANTAMIENTO"
        );

        const asignacionesEntregable = items.filter(
          (item) => item.faseTrabajo.name === "ENTREGABLE"
        );

        const asignacionesMantenimiento = items.filter(
          (item) => item.faseTrabajo.name === "MANTENIMIENTO"
        );

        return (
          <div
            style={{
              background: "#f9f9f9",
              width: "86vw",
              padding: 20,
              borderRadius: 12,
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <h2 style={{ margin: 0 }}>
                Asignaciones: {formatEmpresa(row.original?.nombre) || ""}
              </h2>

              <CustomButton
                color={"#FFFFFF"}
                background={"#223D51"}
                text="Reporte general"
                width="180px"
                height="36px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={async () => {
                  try {
                    setShowLoader(true);
                    const blob = await abrirReporte(API_URL, row.original.id);
                    setShowLoader(false);
                    descargarReporte(
                      `Reporte General ${row.original.id}`,
                      blob
                    );
                  } catch (error) {
                    setShowLoader(false);
                    setShowSnackbar(true);
                    setSnackbarMessage(
                      "Ocurrió un error al generar el reporte."
                    );
                  }
                }}
                type="button"
                src={DescargarG}
                icon={true}
                iconW="16px"
                iconH="16px"
                iconM="8px"
              />
            </div>

            {(() => {
              const { hasLev, hasImp, hasMant } = detectTipos(items);
              const id = row.original.id;
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <Accordion disabled={!hasLev}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ flexDirection: "row-reverse" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "190px 120px",
                          columnGap: "10px",
                        }}
                      >
                        <h2
                          style={{
                            margin: "0 0 0 8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          Levantamientos{" "}
                          <span>({asignacionesLevantamiento.length})</span>
                        </h2>
                        <Box
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              setShowLoader(true);
                              const blob = await abrirReporte(
                                API_URL,
                                id,
                                "LEVANTAMIENTO"
                              );
                              setShowLoader(false);
                              descargarReporte(
                                `Reporte de Levantamiento ${id}`,
                                blob
                              );
                            } catch (error) {
                              setShowLoader(false);
                              setShowSnackbar(true);
                              setSnackbarMessage(
                                "Ocurrió un error al generar el reporte."
                              );
                            }
                          }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            px: 2,
                            py: "4px",
                            border: "1px solid #223D51",
                            borderRadius: "4px",
                            color: "#223D51",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: 700,
                            cursor: "pointer",
                            userSelect: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(34, 61, 81, 0.1)",
                            },
                          }}
                        >
                          <img
                            style={{ marginRight: 0 }}
                            src={DescargarG2}
                            alt=""
                          />
                          Descargar
                        </Box>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {hasLev ? (
                        <TablaAsignaciones
                          asignaciones={asignacionesLevantamiento}
                          user={user}
                          API_URL={API_URL}
                          trabajo={row.original}
                          fase="LEVANTAMIENTO"
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion disabled={!hasImp}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ flexDirection: "row-reverse" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "190px 120px",
                          columnGap: "10px",
                        }}
                      >
                        <h2
                          style={{
                            margin: "0 0 0 8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          Implementaciones{" "}
                          <span>({asignacionesEntregable.length})</span>
                        </h2>

                        <Box
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              setShowLoader(true);
                              const blob = await abrirReporte(
                                API_URL,
                                id,
                                "ENTREGABLE"
                              );
                              descargarReporte(
                                `Reporte de Implementación ${id}`,
                                blob
                              );
                            } catch (error) {
                              setShowLoader(false);
                              setShowSnackbar(true);
                              setSnackbarMessage(
                                "Ocurrió un error al generar el reporte."
                              );
                            }
                          }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            px: 2,
                            py: "4px",
                            border: "1px solid #223D51",
                            borderRadius: "4px",
                            color: "#223D51",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: 700,
                            cursor: "pointer",
                            userSelect: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(34, 61, 81, 0.1)",
                            },
                          }}
                        >
                          <img
                            style={{ marginRight: 0 }}
                            src={DescargarG2}
                            alt=""
                          />
                          Descargar
                        </Box>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {hasImp ? (
                        <TablaAsignaciones
                          asignaciones={asignacionesEntregable}
                          user={user}
                          API_URL={API_URL}
                          trabajo={row.original}
                          fase="ENTREGABLE"
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion disabled={!hasMant}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ flexDirection: "row-reverse" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "190px 120px",
                          columnGap: "10px",
                        }}
                      >
                        <h2
                          style={{
                            margin: "0 0 0 8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          Mantenimientos{" "}
                          <span>({asignacionesMantenimiento.length})</span>
                        </h2>

                        <Box
                          onClick={async (e) => {
                            e.stopPropagation();

                            try {
                              setShowLoader(true);
                              const blob = await abrirReporte(
                                API_URL,
                                id,
                                "MANTENIMIENTO"
                              );
                              descargarReporte(
                                `Reporte de Mantenimiento ${id}`,
                                blob
                              );
                            } catch (error) {
                              setShowLoader(false);
                              setShowSnackbar(true);
                              setSnackbarMessage(
                                "Ocurrió un error al generar el reporte."
                              );
                            }
                          }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            px: 2,
                            py: "4px",
                            border: "1px solid #223D51",
                            borderRadius: "4px",
                            color: "#223D51",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: 700,
                            cursor: "pointer",
                            userSelect: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(34, 61, 81, 0.1)",
                            },
                          }}
                        >
                          <img
                            style={{ marginRight: 0 }}
                            src={DescargarG2}
                            alt=""
                          />
                          Descargar
                        </Box>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {hasMant ? (
                        <TablaAsignaciones
                          asignaciones={asignacionesMantenimiento}
                          user={user}
                          API_URL={API_URL}
                          trabajo={row.original}
                          fase="MANTENIMIENTO"
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            })()}
          </div>
        );
      }

      return (
        <div
          style={{
            background: "#f9f9f9",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "86vw",
            padding: 20,
            gap: 20,
          }}
        >
          <h2 style={{ margin: 0 }}>
            Tracking: {formatEmpresa(row.original.nombre) || ""}
          </h2>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "600px",
              background: "#fff",
              padding: "10px 30px",
              borderRadius: 12,
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              alignItems: "center",
            }}
          >
            <h2 style={{ margin: 0 }}>Etapa</h2>
            <h2 style={{ margin: 0 }}>Detalles</h2>
            <h2 style={{ margin: 0 }}>Acciones</h2>
          </div>
          <TrackerProjectsStepper
            API_URL={API_URL}
            events={events}
            user={user}
            id_trabajo={row.original.id}
            setEvents={setEvents}
            nombre={row.original.nombre}
            pm={row.original?.proyecto?.usuarioPM}
          />
        </div>
      );
    },
    [detailMode, events, tableInstance]
  );

  const options = useMemo(
    () => ({
      enableColumnFilters: false,
      enableSorting: true,
      enablePagination: true,
      manualPagination: true,
      rowCount: rowCount,
      onPaginationChange: setPagination,
      state: {
        pagination,
      },
      localization: { ...MRT_Localization_ES, expand: "Tracker" },
      enableExpandAll: false,
      muiExpandButtonProps: ({ row }) => {
        const isTrackerOpen = row.getIsExpanded() && detailMode === "tracker";
        return {
          title: "Ver tracker",
          children: isTrackerOpen ? (
            <ArrowDropUpIcon color="success" />
          ) : (
            <ArrowDropDownIcon color="success" />
          ),
          onClick: () => toggleRowWithMode(row, "tracker"),
        };
      },
      renderDetailPanel,
    }),
    [renderDetailPanel, detailMode, tableInstance, pagination, rowCount]
  );

  // ChinchetaDesactivada
  const items = [
    {
      texto: "Clientes",
      icon: <img src={Documento} alt="Inicio" />,
      url: "/proyectos/clientes",
      chincheta: arrayViews.includes(2) ? (
        <img className="menu-icon-svg" src={Chincheta} alt="Clientes" />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Clientes"
        />
      ),
      onIconClick: () => handleClick(2),
    },
    {
      texto: "Centros de carga",
      icon: <img src={CentroCarga} alt="Inicio" />,
      url: "/proyectos/centros",
      chincheta: arrayViews.includes(3) ? (
        <img className="menu-icon-svg" src={Chincheta} alt="Centros de carga" />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Centros de carga"
        />
      ),
      onIconClick: () => handleClick(3),
    },
    {
      texto: "EDTs",
      icon: <img src={Documento} alt="EDTs" />,
      url: "/proyectos/edts",
    },
    {
      texto: "Nuevo proyecto",
      icon: <img src={NuevoProyecto} alt="Inicio" />,
      url: "/proyectos/nuevo",
    },
    {
      texto: "Proyectos",
      icon: <img src={Proyecto} alt="Inicio" />,
      url: "/proyectos/todos",
      chincheta: arrayViews.includes(1) ? (
        <img className="menu-icon-svg" src={Chincheta} alt="Proyectos" />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Proyectos"
        />
      ),
      onIconClick: () => handleClick(1),
    },
    {
      texto: "Mapa de proyectos",
      icon: <img src={Ubicacion} alt="Inicio" />,
      url: "/proyectos/mapa",
      chincheta: arrayViews.includes(4) ? (
        <img
          className="menu-icon-svg"
          src={Chincheta}
          alt="Mapa de Proyectos"
        />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Mapa de proyectos"
        />
      ),
      onIconClick: () => handleClick(4),
    },
  ];

  const handleClick = async (num) => {
    // Convertir user.vistasProyectos a array de números
    let arrayViews = user.vistasProyectos
      .split(",")
      .map((num) => parseInt(num.trim(), 10));

    // Si el número ya está en el array, mostrar alerta y salir
    if (arrayViews.includes(num)) {
      confirmDialog({
        html: `<p class="text-dialog">La vista ya está incluida. ¿Deseas excluirla?</p>`,
        icon: "warning",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        onConfirm: async () => {
          arrayViews = arrayViews.filter((n) => n !== num);

          // Si lo eliminamos, actualizar la base de datos y salir
          const viewsTexto = arrayViews.sort((a, b) => a - b).join(",");

          try {
            const response = await changeViewProjects(
              API_URL,
              viewsTexto,
              user.id
            );
            if (response === 200) {
              setUser((prevUser) => ({
                ...prevUser,
                vistasProyectos: viewsTexto,
              }));
            }
          } catch (error) {
            console.error("Error en la actualización:", error);
          }

          return; // Salir de la función para evitar que se siga ejecutando
        },
      });
    }

    // Agregar el nuevo número
    arrayViews.push(num);

    // Ordenar el array y convertirlo a string
    const sortedArray = arrayViews.sort((a, b) => a - b);
    const viewsTexto = sortedArray.join(",");

    try {
      // Hacer la petición PUT para actualizar el usuario
      await changeViewProjects(API_URL, viewsTexto, user.id).then(
        (response) => {
          if (response === 200) {
            setUser((prevUser) => ({
              ...prevUser,
              vistasProyectos: viewsTexto,
            }));
          }
        }
      );
    } catch (error) {
      console.error("Error en la actualización:", error);
    }
  };

  return (
    <div className="prj-container" style={{ display: "flex", width: "100%" }}>
      <LoaderDialog open={showLoader} />

      <div className="prj-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={items} />
      </div>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <div
        className="prj-content"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "90%",
        }}
      >
        {/* Contenedor superior */}
        <div className="prj-top" style={{ display: "flex", flex: 1 }}>
          {/* Primera columna del contenedor superior */}
          <div
            className="prj-left"
            style={{
              flex: 1,
              padding: "10px",
              width:
                arrayViews.includes(2) &&
                !arrayViews.includes(3) &&
                !arrayViews.includes(4)
                  ? "100%"
                  : "60%",
            }}
          >
            {arrayViews.includes(2) && <Clients clients={clients} />}
          </div>
          {/* Segunda columna del contenedor superior */}
          <div
            className="prj-right"
            style={{
              flex: 1,
              padding: "10px",
              width: "40%",
              display:
                arrayViews.includes(2) &&
                !arrayViews.includes(3) &&
                !arrayViews.includes(4)
                  ? "none"
                  : "block",
            }}
          >
            {arrayViews.includes(4) ? (
              <>
                <h1 className="map-title">Mapa de proyectos</h1>
                <div
                  className="prj-mapWrap"
                  style={{ height: "800px", overflow: "hidden" }}
                >
                  <MapElement markers={markers} />
                </div>
              </>
            ) : null}
          </div>
        </div>

        {/* Contenedor inferior */}
        {arrayViews.includes(1) && (
          <div
            className="prj-bottom"
            style={{ display: "flex", height: "100%" }}
          >
            <div style={{ flex: 1, padding: "10px", width: "100%" }}>
              <div
                className="prj-actions"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px", // espacio entre título y botón
                  marginBottom: "16px",
                }}
              >
                <h2 style={{ margin: 0 }}>Centros de carga</h2>
                <CustomButton
                  background={"#223D51"}
                  width={"120px"}
                  height={"32px"}
                  fontSize={"12px"}
                  color={"#FFFFFF"}
                  text={"Ver todos"}
                  fontWeight={700}
                  fontStyle={"normal"}
                  border={"0.5px solid #C3C3C3"}
                  icon={true}
                  src={Personas}
                  iconW={"12px"}
                  iconM={"5px"}
                  onClick={() => navigate("/proyectos/centros")}
                />
              </div>
              <div className="prj-tableWrap" style={{ width: "100%" }}>
                <TablaMRT
                  columns={columns}
                  data={sortedData}
                  options={options}
                  onTableReady={(table) => setTableInstance(table)}
                />
              </div>
            </div>
          </div>
        )}

        {arrayViews.includes(3) && (
          <div
            className="prj-workcenter"
            style={{ flex: 1, padding: "10px", width: "100%" }}
          >
            <WorkCenter
              API_URL={API_URL}
              companies={companies}
              perfiles={perfiles}
              dashboard={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
